"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scanQrToConnectText = void 0;
const scanQrToConnectText = exports.scanQrToConnectText = 'Add to Contacts';